import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import IndexPage from "./pages/IndexPage";
import ProjectPage from "./pages/ProjectPage";
import NotFoundPage from "./pages/NotFoundPage";

/**
 * Routes. You don't need to add a route for a new project: `/:slug` matches
 * any project URL and <ProjectPage /> looks it up in `src/data/projects.js`.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<IndexPage />} />
          {/* The old About page now lives on the home page */}
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/:slug" element={<ProjectPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
